import BaseObject from './BaseObject';
import { Matrix4, Mesh } from 'three';
import {MaterialTypes, ObjectDescription, ObjectTypes, PonticObjectDescription} from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';
import {Dictionary} from '@types';
import ToothObject from '@view/widgets/Scene/WebGLScene/objects/ToothObject';


class PonticObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.Pontic);
  }

  static async create(
    description: PonticObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.Pontic)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    ToothObject.updateOcclusions(mesh as Mesh, description);

    const obj = new PonticObject(mesh);
    obj.setInitial(position, rotation, scale);
    // obj.addToScene(scene);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }

  async update (description: ObjectDescription, objects: Dictionary<BaseObject>) {
    ToothObject.updateOcclusions(this._mesh as Mesh, description);

    if (description.transform) {
      this.resetTransformation();

      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      this._mesh.applyMatrix4(matrix);
    }

    this._mesh.visible = description.visible;
  }
}

export default PonticObject;
